import { createReducer } from "@reduxjs/toolkit";
import type { UpdateState } from "@redux/state/shared-types";
import { resetUpdateTeacherSettings, updateTeacherSettings } from "./update-teacher-settings";

const initialState: UpdateState = { justUpdatedId: null, processing: "idle" };

export const updateTeacherSettingsReducer = createReducer<UpdateState>(initialState, builder => {
  builder.addCase(updateTeacherSettings.fulfilled, (state, { payload }) => {
    return {
      ...state,
      justUpdatedId: payload,
      processing: "success",
    };
  });
  builder.addCase(updateTeacherSettings.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(updateTeacherSettings.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetUpdateTeacherSettings, () => {
    return initialState;
  });
});
